import * as React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import CorrelationSummary from "event-correlation/CorrelationSummary";
import SigmaCorrelationLicenseStatus from "./SigmaCorrelationLicenseStatus";
import useSigmaCorrelationLicenseStatus from "./hooks/useSigmaCorrelationLicenseStatus";
const SigmaCorrelationSummaryContainer = ({ ...otherProps }) => {
  const { t } = useTranslation("enterprise_security_sigma");
  const licenseStatus = useSigmaCorrelationLicenseStatus();
  if (licenseStatus.loading) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: t("sigma_correlation_summary.loading") });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SigmaCorrelationLicenseStatus, { licenseStatus }), /* @__PURE__ */ React.createElement(CorrelationSummary, { ...otherProps }));
};
export default SigmaCorrelationSummaryContainer;
